import { RIGHTS } from '.'

/** O Administrador possui todos os acessos disponíveis */
export const adminRights = [...Object.values(RIGHTS)]

export default adminRights
